import axios from 'axios';
import { toast } from 'react-toastify';
// import logger from './logService';

// ---- To set cookie from server, withCredentials should be set true
axios.defaults.withCredentials = true;

// ---- Request interceptor for API calls
axios.interceptors.request.use(
  (config) => {
    // config.headers['Referrer-Policy'] = 'same-origin';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ---- Response interceptor for API calls
axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) toast.error('An unexpected error occured');
  // logger.log(error);
  return Promise.reject(error);
});

// ---- sets auth header
function setJwt(jwt) {
  if (jwt) axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt
};
